Promise = require 'bluebird'

module.exports = (obj, methodName, args...) ->
  Promise.fromNode (next) ->
    obj[methodName](args..., next)
